module.exports = {
  lang: {
    t1: `Beranda`,
    t2: `Kartu nama`,
    t3: `Ikuti`,
    t4: `Kontak`,
    t5: `Pesan`,
    t6: `Masuk`,
    t7: `Daftar`,
    t8: `Platform baru konektivitas bisnis global, medan baru untuk pemasaran digital perusahaan`,
    t9: `WeMeet - Masuk dengan Nomor Ponsel`,
    t10: `Nomor Ponsel`,
    t11: `Kode Verifikasi`,
    t12: `Silakan masukkan nomor ponsel Anda`,
    t13: `Silakan masukkan kode verifikasi`,
    t14: `Mendapatkan`,
    t15: `Masuk`,
    t16: `Silakan masukkan nomor ponsel dengan format yang benar`,
    t17: `Kode verifikasi telah dikirim`,
    t18: `Kode verifikasi yang dimasukkan salah. Mohon periksa dan masukkan kembali.`,
    t19: `Login berhasil`,
    t20: `Kode verifikasi Anda adalah (0). Harap gunakan dalam waktu {1} menit.`,
    t21: `Batalkan`,
    t22: `Konfirmasi`,
    t23: `Tips Hangat`,
    t24: `Pendaftaran akun WeMeet Anda belum selesai. Lakukan tindakan sekarang untuk menyelesaikan proses pendaftaran dan nikmati beragam interaksi serta kemungkinan tak terbatas.`,
    t25: `Menuju Daftar`,
    t26: `Masuk WeMeet melalui email`,
    t27: `Nama akun`,
    t28: `Masukkan alamat email Anda`,
    t29: `Kata sandi`,
    t30: `Masukkan kata sandi Anda`,
    t31: `Lupa kata sandi?`,
    t32: `Masuk`,
    t33: `Cara masuk lainnya`,
    t34: `Sudah terdaftar di aplikasi WeMeet Mini? Gunakan sekarang.`,
    t35: `Masuk dengan Nomor Telepon`,
    t36: `Harap masukkan surel Anda terlebih dahulu.`,
    t37: `Harap masukkan kata sandi Anda terlebih dahulu.`,
    t38: `Format alamat email salah`,
    t39: `Jika Anda sudah memiliki akun WeMeet, Anda dapat langsung masuk`,
    t40: `Masuk`,
    t41: `Foto profil`,
    t42: `Mohon unggah foto profil asli`,
    t43: `Nama lengkap`,
    t44: `Nama depan`,
    t45: `Nama belakang`,
    t46: `Nama organisasi`,
    t47: `Mohon masukkan nama lembaga Anda`,
    t48: `Jabatan`,
    t49: `Mohon masukkan nama jabatan Anda di lembaga tersebut`,
    t50: `Alamat email`,
    t51: `Masukkan alamat email Anda`,
    t52: `Nomor Ponsel`,
    t53: `Silakan masukkan nomor ponsel Anda`,
    t54: `Wilayah`,
    t55: `Silakan pilih wilayah`,
    t56: `Zona`,
    t57: `Silakan pilih provinsi, kota, kecamatan`,
    t58: `Alamat`,
    t59: `Mohon masukkan alamat Anda`,
    t60: `Saya telah membaca dan menyetujui`,
    t61: `Ketentuan Layanan`,
    t62: `Kebijakan Privasi`,
    t63: `Lanjutkan`,
    t64: `Silakan centang terlebih dahulu Perjanjian Pengguna`,
    t65: `Mohon masukkan nama Anda`,
    t66: `Mohon isi nama keluarga Anda`,
    t67: `Mohon isi email Anda terlebih dahulu`,
    t68: `Mohon isi nama organisasi Anda terlebih dahulu`,
    t69: `Format alamat email salah`,
    t70: `Batalkan`,
    t71: `Selesai`,
    t72: `Verifikasi Nomor HP`,
    t73: `Nomor Ponsel`,
    t74: `Kode Verifikasi`,
    t75: `Silakan masukkan kode verifikasi`,
    t76: `Mendapatkan`,
    t77: `Lewati Verifikasi`,
    t78: `Kirim`,
    t79: `Terverifikasi`,
    t80: `Kode verifikasi yang dimasukkan salah. Mohon periksa dan masukkan kembali.`,
    t81: `Dilewati`,
    t82: `Tips Hangat`,
    t83: `Nomor telepon yang Anda masukkan telah terdaftar dengan akun WeMeet. Tidak perlu mendaftar ulang, silakan masuk sekarang.`,
    t84: `Menuju halaman masuk`,
    t85: `Tips Hangat`,
    t86: `Alamat email yang Anda masukkan telah terdaftar dengan akun WeMeet. Tidak perlu mendaftar ulang, silakan masuk sekarang.`,
    t87: `Menuju halaman masuk`,
    t88: `Tautan verifikasi telah dikirimkan.`,
    t89: `Silakan periksa kotak masuk Anda dan klik tautan untuk menyelesaikan pendaftaran.`,
    t90: `Sudah dipahami`,
    t91: `Selamat bergabung di WeMeet`,
    t92: `Selamat datang di WeMeet! Silakan klik tombol untuk menyelesaikan pendaftaran Anda. Peringatan hangat: Tautan ini berlaku selama 24 jam, harap segera melakukan tindakan.`,
    t93: `Selesai mendaftar`,
    t94: `Email Anda sudah diaktifkan. Silakan masukkan kata sandi Anda.`,
    t95: `Masukkan kata sandi`,
    t96: `Masukkan kata sandi Anda`,
    t97: `Konfirmasi kata sandi`,
    t98: `Silakan masukkan kata sandi Anda sekali lagi`,
    t99: `Harus mengandung kombinasi huruf besar, huruf kecil, angka, dan karakter khusus, dengan panjang antara 8-20 karakter`,
    t100: `Masukkan kata sandi Anda`,
    t101: `Silakan masukkan kata sandi Anda sekali lagi`,
    t102: `Kata sandi tidak sama`,
    t103: `Selamat! Anda telah menyelesaikan pendaftaran`,
    t104: `Anda sudah masuk ke WeMeet, Anda dapat melanjutkan tindakan sebelumnya`,
    t105: `Lanjutkan pengalaman Anda`,
    t106: `Tips Hangat`,
    t107: `Tautan sudah kedaluwarsa. Harap klik tombol untuk mengambil ulang.`,
    t108: `Kirim Ulang`,
    t109: `Ketentuan Layanan`,
    t110: `Kebijakan Privasi`,
    t111: `Mengatur ulang kata sandi`,
    t112: `Silakan masukkan akun yang ingin Anda atur ulang kata sandinya`,
    t113: `Nama akun`,
    t114: `Masukkan alamat email Anda`,
    t115: `Kirim`,
    t116: `Harap masukkan surel Anda terlebih dahulu.`,
    t117: `Format alamat email salah`,
    t118: `Email terkirim`,
    t119: `Silakan cek email Anda, klik link, dan atur ulang kata sandi Anda.`,
    t120: `Sudah dipahami`,
    t121: `Reset Password - WeMeet`,
    t122: `Permintaan reset password Anda telah dikonfirmasi, dan sistem telah menghasilkan tautan reset sementara. Peringatan hangat: Tautan ini berlaku selama 24 jam, harap segera melakukan tindakan.`,
    t123: `Reset Password`,
    t124: `Password Reset Berhasil`,
    t125: `Anda sudah masuk ke WeMeet. Selamat datang kembali.`,
    t126: `Menuju Halaman Utama`,
    t127: `Kontak`,
    t128: `Permintaan kontak baru`,
    t129: `Setuju`,
    t130: `Abaikan`,
    t131: `Disetujui`,
    t132: `Diabaikan`,
    t133: `Mengikuti`,
    t134: `Diikuti`,
    t135: `Pesan`,
    t136: `Permintaan belum diproses`,
    t137: `Masukkan nama atau nomor telepon Anda`,
    t138: `Tidak ada konten yang cocok`,
    t139: `Tidak ada lagi`,
    t140: `Permintaan kontak`,
    t141: `Setuju`,
    t142: `Abaikan`,
    t143: `Disetujui`,
    t144: `Diabaikan`,
    t145: `Ruang AI WeMeet`,
    t146: `Mengikuti`,
    t147: `Berhenti mengikuti`,
    t148: `vCard`,
    t149: `Menghubungkan`,
    t150: `Kirim pesan`,
    t151: `Menunggu persetujuan`,
    t152: `Hapus kontak`,
    t153: `Pengenalan diri`,
    t154: `Profil pribadi`,
    t155: `Tips Hangat`,
    t156: `Permintaan kontak Anda telah dikirim. Setelah disetujui, Anda akan secara otomatis mengikuti TA. Anda juga bisa memilih untuk mengikuti TA sekarang untuk mengetahui lebih banyak tentang mereka.`,
    t157: `Belum mengikuti`,
    t158: `Ikuti`,
    t159: `Mengikuti`,
    t160: `Hapus hubungan kontak`,
    t161: `Setelah menghapus hubungan kontak, pihak lain tidak akan dapat melihat informasi pribadi Anda lagi, tetapi mereka tidak akan secara bersamaan menghapus pengikut Anda.`,
    t162: `Pikirkan lagi`,
    t163: `Hapus kontak`,
    t164: `Operasi berhasil`,
    t165: `Asisten AI WeMeet`,
    t166: `Silakan masukkan pertanyaan Anda`,
    t167: `Kirim`,
    t168: `Perhatikan konten interaksi AI mungkin tidak akurat dan tidak mencerminkan pandangan platform.`,
    t169: `Kartu nama WeMeet`,
    t170: `Unduh`,
    t171: `Ubah kartu nama`,
    t172: `Unduh kode QR`,
    t173: `Gambar telah terbentuk. Simpanlah. Pindai kode QR untuk menyimpan kontak.`,
    t174: `Foto profil`,
    t175: `Mohon unggah foto profil asli`,
    t176: `Nama lengkap`,
    t177: `Nama depan`,
    t178: `Nama belakang`,
    t179: `Silakan masukkan nama Anda`,
    t180: `Nama organisasi`,
    t181: `Mohon masukkan nama lembaga Anda`,
    t182: `Jabatan`,
    t183: `Mohon masukkan nama jabatan Anda di lembaga tersebut`,
    t184: `Alamat email`,
    t185: `Masukkan alamat email Anda`,
    t186: `Nomor Ponsel`,
    t187: `Silakan masukkan nomor ponsel Anda`,
    t188: `Wilayah`,
    t189: `Silakan pilih wilayah`,
    t190: `Zona`,
    t191: `Silakan pilih provinsi, kota, kecamatan`,
    t192: `Alamat`,
    t193: `Mohon masukkan alamat Anda`,
    t194: `Mohon masukkan nama Anda`,
    t195: `Mohon isi nama keluarga Anda`,
    t196: `Mohon isi email Anda terlebih dahulu`,
    t197: `Mohon isi nama organisasi Anda terlebih dahulu`,
    t198: `Format alamat email salah`,
    t199: `Ruang obrolan`,
    t200: `Galeri foto`,
    t201: `Ambil foto`,
    t202: `Silakan masukkan pesan Anda`,
    t203: `Kirim`,
    t204: `Sudah dibaca`,
    t205: `Belum dibaca`,
    t206: `Batas waktu membatalkan telah habis`,
    t207: `Batalkan`,
    t208: `Foto`,
    t209: `Album`,
    t210: `Memotret`,
    t211: `Memilih dari Album`,
    t212: `Batalkan`,
    t213: `Foto`,
    t214: `Potret`,
    t215: `Pratinjau`,
    t216: `Selesai`,
    t217: `Ruang WeMeet AI`,
    t218: `Hubungi Kami`,
    t219: `Hubungi saya`,
    t220: `Nama lengkap`,
    t221: `Organisasi`,
    t222: `Jabatan`,
    t223: `Telepon`,
    t224: `Alamat email`,
    t225: `Wilayah`,
    t226: `Zona`,
    t227: `Alamat`,
    t228: `Mohon masukkan nama Anda`,
    t229: `Silakan isi nama instansi Anda`,
    t230: `Silakan isi jabatan Anda`,
    t231: `Silakan masukkan nomor telepon Anda`,
    t232: `Silakan isi alamat email Anda`,
    t233: `Silakan pilih wilayah`,
    t234: `Silakan pilih provinsi, kota, kecamatan`,
    t235: `Silakan masukkan alamat`,
    t236: `Niat`,
    t237: `Membeli produk`,
    t238: `Produk agen`,
    t239: `Kerjasama pasar`,
    t240: `Lainnya`,
    t241: `Mohon masukkan nama Anda`,
    t242: `Silakan isi nama instansi Anda`,
    t243: `Silakan isi alamat email Anda`,
    t244: `Format alamat email salah`,
    t245: `Pesan telah dikirimkan`,
    t246: `Tinggalkan pesan`,
    t247: `Masukkan konten pertanyaan Anda`,
    t248: `Konfirmasi`,
    t249: `Silakan login atau daftar terlebih dahulu`,
    t250: `Pengikut`,
    t251: `Hubungi kami`,
    t252: `Produk`,
    t253: `Tim`,
    t254: `Tinjauan umum`,
    t255: `Album`,
    t256: `Kualifikasi`,
    t257: `Modal dasar`,
    t258: `Tanggal pendirian`,
    t259: `Alamat terdaftar`,
    t260: `Hulu`,
    t261: `Tengah sungai`,
    t262: `Hilir`,
    t263: `Ngành công nghiệp liên quan`,
    t264: `Proses`,
    t265: `Simpan`,
    t266: `Terverifikasi`,
    t267: `Cina`,
    t268: `Inggris`,
    t269: `Prancis`,
    t270: `Rusia`,
    t271: `Spanyol`,
    t272: `Jepang`,
    t273: `Korea`,
    t274: `Indonesia`,
    t275: `Vietnam`,
    t276: `Jerman`,
    t277: `Turki`,
    t278: `Italia`,
    t279: `Portugis`,
    t280: `Thailand`,
    t281: `Melayu`,
    t282: `Arab`,
    t283: `Nama pengguna atau kata sandi salah`,
    t284: `Silakan baca dan setujui Perjanjian Pengguna WeMeet terlebih dahulu`,
    t285: `Tidak ada konten yang sesuai`,
    t286: `Jenis`,
    t287: `Atribut`,
    t288: `Detail`,
    t289: `Lainnya`,
    t290: `Total 2 produk`,
    t291: `{1} mengundang Anda untuk mengunjungi WeMeet AI Space dari {2}`,
    t292: `Klik di sini untuk melihat contoh atau masukkan pertanyaan:`,
    t293: `Segarkan`,
    t294: `Anda juga dapat mengklik kartu nama di bawah untuk menambahkan kontak dan mendapatkan informasi lebih lanjut:`,
    t295: `Pelajari`,
    t296: `Pertemuan Digital WeMeet`,
    t297: `Pameran Digital WeMeet`,
    t298: `WeMeet 명함과 WeMeet AI 공간`,
    t299: `Bagaimana menjadi anggota organisasi WeMeet`,
    t300: `Layanan Konferensi Digital WeMeet menyediakan Anda dengan solusi rapat online yang komprehensif, termasuk namun tidak terbatas pada pembuatan dan publikasi rapat, manajemen pendaftaran peserta, check-in elektronik, penjadwalan rapat, berbagi materi rapat, diskusi interaktif real-time, dan interaksi tamu.`,
    t301: `WeMeet Pameran Digital, membantu membangun situs web resmi mikro pameran dengan cepat. Menampilkan informasi pameran, pengantar pameran, siaran langsung pameran, pendaftaran pameran, jadwal acara, dan lainnya, memungkinkan perusahaan yang berpartisipasi dan audiens untuk dengan mudah memahami detail pameran. Untuk menggunakan fitur WeMeet Pameran Digital, harap selesaikan proses masuk institusi terlebih dahulu. Klik "Saya", gulir ke bawah ke "Pusat Layanan" - "Masuk Institusi" dan ikuti petunjuk untuk menyelesaikan proses masuk.`,
    t302: `Pengguna pribadi WeMeet hanya perlu memberikan izin ID WeChat, nomor telepon, dan menyelesaikan pendaftaran platform untuk mendapatkan kartu bisnis digital pribadi dan memelihara Lounge AI pribadi mereka (termasuk riwayat pribadi, pembaruan, foto, dokumen, dll.).`,
    t303: `Klik op "Saya" op de onderste menubalk van de mini-programma om de persoonlijke visitekaartpagina bij te werken en de persoonlijke startpagina te verbeteren.`,
    t304: `Kombinasi huruf besar dan kecil, angka, dan tanda baca, dengan panjang antara 8-20 karakter.`,
    t305: `Masukkan nama produk`,
    t306: `Tidak ada lagi`,
    t307: `Klik sudut kanan atas`,
    t308: `Pilih cara berbagi yang Anda sukai`,
    t309: `Saya mengerti`,
    t310: `Silakan lengkapi registrasi dan login terlebih dahulu`,
    t311: `Pelajari lebih lanjut`,
    t312: `Produk Terkait`,
    t313: `Terima kasih atas kunjungannya`,
    t314: `Keluar`,
    t315: `Organisasi yang diikuti`,
    t316: `Sebelumnya`,
    t317: `Selanjutnya`,
    t318: `Tidak ada`,
    t319: `{1} mengundang Anda untuk mengunjungi {2}`,
    t320: `Lounge AI belum memelihara bahasa saat ini`,
    t321: `Lounge AI telah beralih ke bahasa saat ini`,
    t322: `Tautan telah diaktifkan`,
    t323: `Jaringan sibuk, silakan coba lagi nanti`,
    t324: `Detail produk telah beralih ke bahasa saat ini`,
    t325: `Detail produk saat ini tidak dikelola dalam bahasa ini`,
    t326: `Halo, saya adalah asisten AI pintar WeMeet, siap memberikan layanan yang perhatian kapan pun! Bagaimana saya bisa membantu Anda?`,
    t327: `Masukkan Nama`,
    t328: `Saya telah menemukan informasi kontak yang relevan, silakan periksa kartu kontak di bawah ini.`,
    t329: `Lampiran`,
    t330: `Saya tidak menemukan informasi kontak yang relevan.`,
    t331: `Saya telah meneruskan pertanyaan Anda kepada rekan kerja yang bertanggung jawab di bawah ini; Anda juga dapat mengklik kartu nama untuk segera menghubungi.`,
    t332: `Pameran`,
    t333: `Silakan masukkan`,
    t334: `Pengguna`,
    t335: `Tidak ada lagi`,
    t336: `Penyegaran berhasil`,
    t337: `Memuat`,
    t338: `Lepaskan untuk Segarkan`,
  },
};

// 印度尼西亚
